module.exports = __webpack_public_path__ + "static/img/anli_001.cd8c81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli_001.png
// module id = NWeP
// module chunks = 1